export default __webpack_public_path__ + "static/media/zubut-logo.82bc5eaa.png";